import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../services/utils.service'; 

@Pipe({
    name: 'numberFormat',
    standalone: false
})

export class NumberFormatPipe implements PipeTransform {
  transform(value: number,decimalPlaces:number): number { 

    return  UtilsService.FormatNumberWithDecimalPlacesWithoutCurrecyFormat(value,decimalPlaces);
  }
}